import { removeAddon, updateAddon } from '@/neon/cart.js';

const quickCartItem = item => {
  const decrease = item.querySelector('.js-remove-single');
  const increase = item.querySelector('.js-add-single');
  const currentQty = item.querySelector('.js-single-quantity').innerHTML;
  const id = item.getAttribute('data-id');

  decrease.addEventListener('click', e => {
    e.preventDefault();
    if (currentQty === 1) {
      removeAddon(id);
    } else {
      updateAddon(id, parseInt(currentQty) - 1);
    }
  });

  increase.addEventListener('click', e => {
    e.preventDefault();
    updateAddon(id, parseInt(currentQty) + 1);
  });
};

export default quickCartItem;
